/* eslint-disable import/no-restricted-paths */
import * as React from 'react';

import { IGetSpecialPromoResponse } from '../../repositories/special-promos/v1/get-special-promo';

import { YmapsApi } from '../../../browser/ymaps/ymaps-api';
import { About } from '../about';
import { Banners } from '../banners';
import { CallToAction } from '../call-to-action';
import { Footer } from '../footer';
import { ScrollFragment, FragmentTypes } from '../fragment';
import { Header } from '../header';
import { JkSection } from '../jk-section';
import { Map } from '../map';

import * as styles from './app.css';
import { ILogger } from '@cian/logger';
import { AdfoxPixelContainer } from '../../containers/AdfoxPixel';

interface IAppProps {
  ymaps?: YmapsApi;
  logger: ILogger;
  specialPromo: IGetSpecialPromoResponse;
  currentYear: number;
}

interface IAppState {
  hash?: string;
}

const FRAGMENT_OFFSET = -90;

export class App extends React.PureComponent<IAppProps, IAppState> {
  public state = { hash: '' };

  public render() {
    const { ymaps, specialPromo, currentYear, logger } = this.props;

    return (
      <div className={styles['page']}>
        {this.renderHeader()}
        <Banners banners={specialPromo.bannerList} logo={specialPromo.logoBig} />
        <div className={styles['container']}>
          <ScrollFragment name={FragmentTypes.Jks} offset={FRAGMENT_OFFSET} hash={this.state.hash}>
            {specialPromo.pinImage && (
              <JkSection
                jks={specialPromo.jkList}
                builderNameGenitive={specialPromo.nameGenitive}
                mainColor={specialPromo.colorHex}
                mapSettingsJk={specialPromo.mapSettingsJk}
                pinImage={specialPromo.pinImage}
                ymaps={ymaps}
              />
            )}
          </ScrollFragment>
          {this.renderAboutSection()}
          {this.renderOfficesMap()}
          <CallToAction phone={specialPromo.phone ?? ''} />
          <AdfoxPixelContainer puids={specialPromo.puids} logger={logger} />
          <Footer currentYear={currentYear} />
        </div>
      </div>
    );
  }

  private renderOfficesMap() {
    const {
      specialPromo: { officeList, mapSettingsOffice, colorHex, pinImage },
      ymaps,
    } = this.props;

    if (!officeList.length) {
      return null;
    }

    let initialCenter;
    if (mapSettingsOffice && mapSettingsOffice.lat && mapSettingsOffice.lng) {
      initialCenter = [mapSettingsOffice.lat, mapSettingsOffice.lng] as [number, number];
    }

    const officesPins = officeList.map(office => ({
      address: office.address,
      coordinates: { lat: office.mapLat, lng: office.mapLng },
      isMain: office.isMain,
      name: office.name,
      phone: office.phone,
    }));

    return (
      <ScrollFragment name={FragmentTypes.Offices} offset={FRAGMENT_OFFSET} hash={this.state.hash}>
        <h3 className={styles['offices-map-title']}>Офисы продаж</h3>
        <Map
          initialCenter={initialCenter}
          initialZoom={mapSettingsOffice?.zoom ?? undefined}
          mainColor={colorHex}
          mapId="offices-map"
          ymaps={ymaps}
          pinImageUrl={pinImage && pinImage.url ? pinImage.url : undefined}
          pins={officesPins}
        />
      </ScrollFragment>
    );
  }

  private renderAboutSection() {
    const title = this.props.specialPromo.info?.title;
    const html = this.props.specialPromo.info?.html;

    if (html && title) {
      return (
        <ScrollFragment name={FragmentTypes.About} offset={FRAGMENT_OFFSET} hash={this.state.hash}>
          <About title={title} content={html} />
        </ScrollFragment>
      );
    }

    return null;
  }

  private renderHeader() {
    const {
      specialPromo: { officeList, info, name, logoHeader, phone },
    } = this.props;

    const links = [{ title: 'Жилые комплексы', to: FragmentTypes.Jks }];

    if (info && info.title && info.html) {
      links.push({ title: 'О застройщике', to: FragmentTypes.About });
    }

    if (officeList.length) {
      links.push({ title: 'Офисы продаж', to: FragmentTypes.Offices });
    }

    return (
      <Header
        builderName={name}
        links={links}
        logo={logoHeader}
        phone={phone ?? ''}
        onHashChange={hash => this.setState({ hash })}
        hash={this.state.hash}
      />
    );
  }
}
